<template>
    <div id="advertiser-edit-popup">
        <ValidationObserver class="centerx default-input" ref="form" v-slot="{handleSubmit}">
            <vs-row>
                <vs-col vs-w="12">
                    <ValidationProvider vid="teamName" :name="$t('modals.Team_name')"
                                        :rules="{ regex: /^[A-zА-я0-9 ]+$/, required: true, minmax:[3,50]}"
                                        v-slot="{ errors }">
                        <div class="p-2">
                            <label class="text-sm opacity-75">{{$t('modals.Team_name')}}</label>
                            <vs-input
                                class="inputx w-full no_focus"
                                :placeholder="$t('modals.Team_name')"
                                v-model="popupFields.teamName"
                            />
                            <span class="text-danger text-xs" >{{ errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </vs-col>
                <vs-col vs-w="12">
                    <vs-row>
                        <vs-col vs-w="6">
                            <div class="flex p-2">
                                <span>{{ $t('table.Is_internal_team') }}</span>
                                <vs-switch
                                    class="ml-4"
                                    color="success"
                                    v-model="popupFields.is_internal"
                                    icon-pack="feather"
                                    vs-icon-off="icon-x"
                                    vs-icon-on="icon-check"
                                />
                            </div>
                        </vs-col>
                        <vs-col vs-w="6">
                            <div class="flex p-2">
                                <span>{{ $t('table.isHot') }}</span>
                                <vs-switch
                                    class="ml-4"
                                    color="success"
                                    v-model="popupFields.is_hot"
                                    icon-pack="feather"
                                    vs-icon-off="icon-x"
                                    vs-icon-on="icon-check"
                                />
                            </div>
                        </vs-col>
                        <vs-col vs-w="6" v-if="isAutologin">
                            <div class="flex p-2">
                                <span>{{ $t('table.autologin') }}</span>
                                <vs-switch
                                    class="ml-4"
                                    color="success"
                                    v-model="popupFields.is_hide_autologin"
                                    icon-pack="feather"
                                    vs-icon-off="icon-x"
                                    vs-icon-on="icon-check"
                                />
                            </div>
                        </vs-col>
                        <vs-col vs-w="6" v-can="'settings_moderation.team_moderation_toggle'">
                            <div class="flex p-2">
                                <span>FTD</span>
                                <vs-switch
                                    class="ml-4"
                                    color="success"
                                    v-model="popupFields.is_manual_deposit_moderation"
                                    icon-pack="feather"
                                    vs-icon-off="icon-x"
                                    vs-icon-on="icon-check"
                                />
                            </div>
                        </vs-col>
                        <vs-col vs-w="6">
                            <div class="flex p-2">
                                <span>{{ $t('global.acceptDuplicates') }}</span>
                                <vs-switch
                                    class="ml-4"
                                    color="success"
                                    v-model="popupFields.should_skip_double"
                                    icon-pack="feather"
                                    vs-icon-off="icon-x"
                                    vs-icon-on="icon-check"
                                />
                            </div>
                        </vs-col>
                    </vs-row>
                </vs-col>
            </vs-row>
            <div v-if="popupType === 'createTeam'">
                <vs-divider></vs-divider>
                <h6 class="p-2">{{ $t('modals.Manager_info') }}</h6>
                <vs-row>
                    <vs-col vs-w="6">
                        <ValidationProvider vid="name" :name="$t('modals.Manager_name')"
                                            :rules="{ regex: /^[A-zА-я0-9 ]+$/, required: true, minmax:[3,50]}"
                                            v-slot="{ errors }">
                            <div class="p-2">
                                <label class="text-sm opacity-75">{{$t('modals.Manager_name')}}</label>
                                <vs-input
                                    class="inputx w-full no_focus"
                                    :placeholder="$t('modals.Manager_name')"
                                    v-model="popupFields.name"
                                />
                                <span class="text-danger text-xs" >{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>
                    </vs-col>
                    <vs-col vs-w="6">
                        <ValidationProvider vid="email" :name="$t('global.Email')"
                                            rules="required|email|minmax:3,50"
                                            v-slot="{ errors }">
                            <div class="p-2">
                                <label class="text-sm opacity-75">{{$t('global.Email')}}</label>
                                <vs-input
                                    class="inputx w-full no_focus"
                                    :placeholder="$t('global.Email')"
                                    v-model.trim="popupFields.email"
                                />
                                <span class="text-danger text-xs" >{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>
                    </vs-col>
                </vs-row>
                <vs-row>
                    <vs-col vs-w="6">
                        <ValidationProvider vid="password" :name="$t('modals.Password')" rules="required|minmax:6,25"
                                            v-slot="{ errors }">
                            <div class="p-2">
                                <label class="text-sm opacity-75">{{$t('modals.Password')}}</label>
                                <password-input
                                    :placeholder="$t('modals.Password')"
                                    name="password"
                                    v-model="popupFields.password"
                                    @generate="generatePassword"
                                />

                                <span class="text-danger text-xs" >{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>
                    </vs-col>
                    <vs-col vs-w="6">
                        <ValidationProvider vid="confirm_password" :name="$t('modals.Confirm_password')"
                                            rules="required|minmax:6,25|confirmed:password" v-slot="{ errors }">
                            <div class="p-2">
                                <label class="text-sm opacity-75">{{$t('modals.Confirm_password')}}</label>
                                <password-input
                                    :placeholder="$t('modals.Confirm_password')"
                                    name="confirm_password"
                                    v-model="popupFields.confirm_password"
                                    :generator="false"
                                />

                                <span class="text-danger text-xs" >{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>
                    </vs-col>
                </vs-row>
                <vs-row>
                    <vs-col vs-w="12">
                            <ValidationProvider
                                vid="locale"
                                :name="$t('global.Locale')"
                                rules="required"
                                v-slot="{ errors }">
                                <div class="p-2">
                                    <label class="text-sm opacity-75">{{ $t('global.Locale') }}</label>
                                    <v-select
                                        :options="popupFields.locales"
                                        v-model="popupFields.locale"
                                        :clearable="false"
                                        class="mb-4 sm:mb-0 cursor-pointer"
                                    />
                                    <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                                </div>
                            </ValidationProvider>
                    </vs-col>
                </vs-row>
            </div>
            <vs-row>
                <vs-col vs-w="12">
                    <div class="p-2 text-right">
                        <vs-button :disabled="loading" @click.prevent="handleSubmit(submitForm)">{{ $t('buttons.Save') }}</vs-button>
                    </div>
                </vs-col>
            </vs-row>
        </ValidationObserver>
    </div>
</template>

<script>
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import vSelect from 'vue-select'
import EventBus from '../../../store/eventBus'

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        vSelect
    },
    props: ['popupData', 'popupType', 'popupButton'],
    data() {
        return {
            loading: false,
            popupFields: {
                name: '',
                is_manual_deposit_moderation: false,
                is_internal: false,
                is_hide_autologin: false,
                is_hot: false,
                should_skip_double: false,
                locales: [
                    'RU',
                    'EN',
                    'UA'
                ],
                locale: 'RU'
            },
            submitButtonText: ''
        }
    },

    computed: {
        isAutologin() {
            return this.$store.state.isTeamAutologin
        }
    },

    methods: {
        generatePassword(password) {
            this.popupFields.confirm_password = password
        },

        async submitForm() {
            this.loading = true
            const teamData = {
                team: {
                    name: this.popupFields.teamName.trim(),
                    is_internal: this.popupFields.is_internal ? 1 : 0,
                    is_hot: this.popupFields.is_hot ? 1 : 0,
                    is_hide_autologin: this.popupFields.is_hide_autologin ? 1 : 0,
                    is_manual_deposit_moderation: this.popupFields.is_manual_deposit_moderation ? 1 : 0,
                    should_skip_double: this.popupFields.should_skip_double ? 1 : 0
                }
            }

            if (!this.isAutologin) {
                teamData.team.is_hide_autologin = 0
            }

            let dispatchPath = '',
                dispatchData = {}
            if(this.popupType === 'createTeam') {
                dispatchPath = 'create'
                teamData.user = {
                    name: this.popupFields.name.trim(),
                    email: this.popupFields.email.trim(),
                    password: this.popupFields.password.trim(),
                    confirm_password: this.popupFields.confirm_password.trim(),
                    locale: this.popupFields.locale
                }
                dispatchData = {
                    url: this.$url.settings_team.create,
                    data: teamData
                }
            } else {
                dispatchPath = 'edit'
                teamData.team.id = this.popupData.id
                teamData.ids = this.popupData.arrId
                dispatchData = {
                    url: this.$url.settings_team.update,
                    data: teamData.team,
                    ids: this.popupData
                }
            }

            this.$store.dispatch(dispatchPath, dispatchData)
                .then(() => {
                    EventBus.$emit('getTeams')
                    EventBus.$emit('emitPopupEvent', {type: 'close'})
                    if (this.popupData.groupedByAdvertisers){
                        EventBus.$emit('getGroupedTeamsByAdvertiser')
                    }
                })
                .catch(error => {
                    if(error.response) {
                        const template = {
                            'user.name': 'name',
                            'team.name': 'teamName',
                            'user.email': 'email'
                        }

                        const result = Object.fromEntries(Object.entries(error.response.data.result.errors).map(([key, value]) =>
                            [template[key] || key, value]
                        ))

                        const response = (error.response.data.result.errors = result)
                        this.$refs.form.setErrors(this.$errors(response))
                    }
                }).finally(() => this.loading = false)
        }
    },
    mounted() {
        try {
            this.submitButtonText = this.popupButton
            if(this.popupType === 'editTeam') {
                this.popupFields.id = this.popupData.id
                this.popupFields.teamName = this.popupData.name
                this.popupFields.is_internal = this.popupData.is_internal
                this.popupFields.is_hot = this.popupData.is_hot
                this.popupFields.is_hide_autologin = this.popupData.is_hide_autologin
                this.popupFields.is_manual_deposit_moderation = this.popupData.is_manual_deposit_moderation
                this.popupFields.should_skip_double = this.popupData.should_skip_double
            }

            this.$store.commit('UPDATE_LOADER_STATE', false)
        } catch (e) {
            this.$store.commit('UPDATE_LOADER_STATE_SET_ERROR', true)
        }
    }
}
</script>
<style lang="scss">
#user-edit-popup {
    .vs__dropdown-option--selected {
        display: none !important;
    }

    .vs-tabs--li button {
        font-size: 0.8rem;
        line-height: 1;
    }

    .vs-tabs-position-left .vs-tabs--li {
        padding: 0;
    }

    .vx-card .vx-card__collapsible-content .vx-card__body {
        padding: 1rem;
    }

    .vx-card .vx-card__collapsible-content.vs-con-loading__container {
        height: 300px;
    }

    .vs-tabs-position-left .con-ul-tabs {
        width: 180px;
        height: 230px;
        overflow-y: scroll;
    }
}
</style>
